<style lang="scss" src="./FormGroup.scss"></style>
<template>
  <fieldset class="form-group">
    <label class="fgcaption">{{ caption }}</label>
    <p
      v-if="description"
      class="fgdescription">
      {{ description }}
    </p>
    <section class="fgcontainer">
      <slot>
      </slot>
    </section>
  </fieldset>
</template>

<script>
export default {
  name: 'FormGroup',
  props: {
    caption: '',
    description: null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-form-group/FormGroup.vue